import { useNavigate } from "react-router-dom";
import { ArrowLeft, Check, Layers, Download, Save } from "lucide-react";
import { toast } from "sonner";

export const ContinueStep = ({ project }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-xl mx-auto text-center" data-testid="step-4">
      <div className="mb-12">
        <div className="w-16 h-16 mx-auto border border-green-400/30 rounded-sm flex items-center justify-center mb-8 shadow-[0_0_20px_rgba(0,200,100,0.15)]">
          <Check className="w-8 h-8 text-green-400" />
        </div>
        <h2 className="text-3xl font-['Rajdhani'] tracking-wide mb-3">
          CROPS COMPLETE
        </h2>
        <p className="text-cyan-200/40 leading-relaxed">
          Your alternative aspect ratio crops have been applied. Choose how
          you'd like to continue.
        </p>
      </div>

      <div className="space-y-3">
        <button
          onClick={() => navigate(`/project/${project.id}/restripe`)}
          className="w-full p-6 card-glass rounded-sm text-left hover:border-cyan-500/30 transition-all group"
          data-testid="continue-restripe"
        >
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-['Rajdhani'] text-lg tracking-wide group-hover:text-cyan-300 transition-colors">
                RESTRIPE
              </h3>
              <p className="text-sm text-cyan-200/30 mt-1">
                Add or change supers, graphics, end frames, disclaimers and
                audio
              </p>
            </div>
            <Layers className="w-5 h-5 text-cyan-400/30 group-hover:text-cyan-300 transition-colors" />
          </div>
        </button>

        <button
          onClick={() => navigate(`/project/${project.id}/encoding`)}
          className="w-full p-6 card-glass rounded-sm text-left hover:border-cyan-500/30 transition-all group"
          data-testid="continue-encoding"
        >
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-['Rajdhani'] text-lg tracking-wide group-hover:text-cyan-300 transition-colors">
                ENCODE / MASTER
              </h3>
              <p className="text-sm text-cyan-200/30 mt-1">
                Export your cropped versions to various social and broadcast
                specifications
              </p>
            </div>
            <Download className="w-5 h-5 text-cyan-400/30 group-hover:text-cyan-300 transition-colors" />
          </div>
        </button>

        <button
          onClick={() => {
            toast.success("Project saved - you can resume from your dashboard");
            navigate("/dashboard");
          }}
          className="w-full p-6 card-glass rounded-sm text-left hover:border-cyan-500/30 transition-all group"
          data-testid="save-and-exit"
        >
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-['Rajdhani'] text-lg tracking-wide group-hover:text-cyan-300 transition-colors">
                SAVE & EXIT
              </h3>
              <p className="text-sm text-cyan-200/30 mt-1">
                Save as a work in progress and return later
              </p>
            </div>
            <Save className="w-5 h-5 text-cyan-400/30 group-hover:text-cyan-300 transition-colors" />
          </div>
        </button>
      </div>

      <button
        onClick={() => window.history.back()}
        className="mt-8 text-sm text-cyan-400/40 hover:text-cyan-300 flex items-center gap-2 mx-auto transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> Back to workspace
      </button>
    </div>
  );
};
